const toNumber = (value) => {
  if (value == null || value === "" || value === "-") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "boolean") return value ? 1 : 0;

  const cleaned = String(value)
    .trim()
    .replace(/\u00a0/g, " ")
    .replace(/\s/g, "")
    .replace("%", "")
    .replace("₽", "")
    .replace(",", ".");

  if (!cleaned || cleaned === "-") return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
};

export const numberComparator = (a, b) => {
  const na = toNumber(a);
  const nb = toNumber(b);
  if (na == null && nb == null) return 0;
  if (na == null) return -1;
  if (nb == null) return 1;
  return na - nb;
};

export const parseSortDate = (value) => {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    const t = value.getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const s = String(value).trim();

  // Чистое время HH:mm(:ss) — сортируем как секунды от начала суток
  const t = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (t) {
    return Number(t[1]) * 3600 + Number(t[2]) * 60 + Number(t[3] || 0);
  }

  const m = s.match(
    /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/,
  );
  if (m) {
    return new Date(
      Number(m[3]),
      Number(m[2]) - 1,
      Number(m[1]),
      Number(m[4] || 0),
      Number(m[5] || 0),
      Number(m[6] || 0),
    ).getTime();
  }

  const iso = Date.parse(s);
  return Number.isNaN(iso) ? null : iso;
};

export const dateComparator = (a, b) => {
  const ta = parseSortDate(a);
  const tb = parseSortDate(b);
  if (ta == null && tb == null) return 0;
  if (ta == null) return -1;
  if (tb == null) return 1;
  return ta - tb;
};

const normalizeHeader = (headerName) =>
  String(headerName || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const isDateColumn = (col) => {
  const header = normalizeHeader(col.headerName);
  const field = String(col.field || "").toLowerCase();

  if (header === "№" || header === "номер" || header === "код") return false;
  if (/^код\b/.test(header) || /^№/.test(header)) return false;

  if (/(дата|время)/.test(header)) return true;

  if (
    field === "time" ||
    field === "date" ||
    field === "createdat" ||
    field === "creationtime" ||
    field === "birthday" ||
    field === "dateformatted"
  ) {
    return true;
  }

  // creationTime, created_at, updatedAt — но не clientdateid / itemid
  if (/(^|_)(createdat|creationtime|birthday)$/.test(field)) return true;
  if (/(time|date)$/.test(field) && !/id$/.test(field)) return true;

  return false;
};

const isNumberColumn = (col) => {
  const header = normalizeHeader(col.headerName);
  const field = String(col.field || "").toLowerCase();

  if (header === "№" || header === "номер" || header === "код") return true;
  if (/^код\b/.test(header) || /\bкод\b/.test(header)) return true;
  if (header === "номер" || /^№/.test(header)) return true;

  if (
    /(сумма|цена|кол-во|количество|скидка|процент|стоимость|бонус|расхождение|наценк|учёт|учет|факт|номер|\bдни\b)/.test(
      header,
    )
  ) {
    return true;
  }
  if (/%|₽/.test(String(col.headerName || ""))) return true;

  if (
    field === "number" ||
    field === "code" ||
    field === "index" ||
    field === "itemid" ||
    field === "id" ||
    field === "total" ||
    field === "price" ||
    field === "amount" ||
    field === "value" ||
    field === "percent" ||
    field === "bonus" ||
    field === "position" ||
    field === "quantity" ||
    field === "difference" ||
    field === "realamount" ||
    field === "frontprice" ||
    field === "salepercent" ||
    field === "discount" ||
    field === "rememberday" ||
    field === "sale" ||
    field === "purchase" ||
    field === "profit" ||
    field === "markup" ||
    /radius/.test(field) ||
    /(amount|price|total|percent|bonus|quantity|value|sum)$/.test(field) ||
    /(^|_)(id|code|number)$/.test(field) ||
    /id$/.test(field)
  ) {
    return true;
  }

  return false;
};

export const enhanceColDefsForSort = (colDefs = []) =>
  colDefs.map((col) => {
    if (!col || col.comparator || col.sortable === false) return col;

    if (isDateColumn(col)) {
      return { ...col, comparator: dateComparator };
    }
    if (isNumberColumn(col)) {
      return { ...col, comparator: numberComparator };
    }
    return col;
  });
